import { get } from './get'
import { getCompare } from './getCompare'
import { getHistory } from './getHistory'
import { getHistoryCompare } from './getHistoryCompare'
import { getRealtime } from './getRealtime'

export default {
  ...get,
  ...getCompare,
  ...getRealtime,
  ...getHistory,
  ...getHistoryCompare
}
